import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Button } from "@material-ui/core";
import { alertError } from "../../../../utils/logger";
import { getTradingOperationById } from "../../../../api/tradingOperations";

function JsonBlock({ title, value }) {
  let text = "—";
  try {
    text =
      value === undefined || value === null
        ? "—"
        : typeof value === "string"
        ? value
        : JSON.stringify(value, null, 2);
  } catch {
    text = String(value);
  }
  return (
    <div className="mb-4">
      <h6 className="font-weight-bold">{title}</h6>
      <pre
        className="p-3 bg-light border rounded"
        style={{ maxHeight: "420px", overflow: "auto", fontSize: "12px" }}
      >
        {text}
      </pre>
    </div>
  );
}

export default function TradingOperationDetailPage() {
  const { id } = useParams();
  const history = useHistory();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getTradingOperationById(id)
      .then((res) => {
        if (res.status === 200) setDoc(res.data);
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se pudo cargar la operación.",
        });
        setDoc(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <Card>
      <CardHeader title="Detalle operación de trading">
        <CardHeaderToolbar>
          <Button variant="outlined" onClick={() => history.push("/trading-operations")}>
            Volver al listado
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {loading && <p>Cargando…</p>}
        {!loading && !doc && <p>No se encontró el documento.</p>}
        {!loading && doc && (
          <>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>ID:</strong> {String(doc._id)}
              </div>
              <div className="col-md-6">
                <strong>Estado:</strong> {doc.status}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Exchange / símbolo:</strong> {doc.exchange} · {doc.symbol}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Lado / intent:</strong> {doc.side} · {doc.intent}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Origen / estrategia:</strong> {doc.source} · {doc.strategy}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Creado / actualizado:</strong>{" "}
                {doc.createdAt ? new Date(doc.createdAt).toLocaleString() : "—"} ·{" "}
                {doc.updatedAt ? new Date(doc.updatedAt).toLocaleString() : "—"}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Precio apertura (petición):</strong>{" "}
                {doc.requestSnapshot?.price != null && doc.requestSnapshot?.price !== ""
                  ? String(doc.requestSnapshot.price)
                  : "—"}
              </div>
              {(doc.status === "closed" || doc.status === "canceled") && (
                <div className="col-md-6 mt-2">
                  <strong>Resumen cierre / cancelación:</strong>{" "}
                  {doc.status === "closed" && doc.closeRecord
                    ? [
                        doc.closeRecord.closePrice != null
                          ? `Pcierre ${doc.closeRecord.closePrice}`
                          : null,
                        doc.closeRecord.zoomexClosedPnl &&
                        doc.closeRecord.zoomexClosedPnl.closedPnlSum != null &&
                        doc.closeRecord.zoomexClosedPnl.closedPnlSum !== ""
                          ? `PnL Zoomex ${doc.closeRecord.zoomexClosedPnl.closedPnlSum}`
                          : null,
                        doc.closeRecord.at
                          ? new Date(doc.closeRecord.at).toLocaleString()
                          : null,
                        doc.closeRecord.closeReason,
                      ]
                        .filter(Boolean)
                        .join(" · ") || "—"
                    : doc.status === "canceled" && doc.cancelRecord
                    ? [
                        doc.cancelRecord.at
                          ? new Date(doc.cancelRecord.at).toLocaleString()
                          : null,
                        doc.cancelRecord.cancelReason,
                      ]
                        .filter(Boolean)
                        .join(" · ") || "—"
                    : "—"}
                </div>
              )}
              {doc.lastCheckedAt && (
                <div className="col-md-6 mt-2">
                  <strong>Última reconciliación:</strong>{" "}
                  {new Date(doc.lastCheckedAt).toLocaleString()}
                </div>
              )}
            </div>

            <JsonBlock title="Contexto exchange" value={doc.exchangeContext} />
            <JsonBlock title="TP / SL / trailing (riskSnapshot)" value={doc.riskSnapshot} />
            <JsonBlock title="Ids externos" value={doc.externalOrderIds} />
            <JsonBlock title="Snapshot de petición (sanitizado)" value={doc.requestSnapshot} />
            <JsonBlock title="Respuesta exchange (recortada)" value={doc.exchangeResponse} />
            <JsonBlock title="Error (apertura o mensaje)" value={doc.error} />
            <JsonBlock
              title="Último error reconciliación"
              value={doc.lastReconciliationError}
            />
            {doc.statusNote && (
              <JsonBlock title="Nota de estado" value={doc.statusNote} />
            )}
            {doc.closeRecord && (
              <JsonBlock title="Auditoría de cierre (closeRecord)" value={doc.closeRecord} />
            )}
            {doc.cancelRecord && (
              <JsonBlock title="Auditoría cancelación (cancelRecord)" value={doc.cancelRecord} />
            )}
            {doc.logHubVsBotId && (
              <p className="text-muted">
                <strong>Log hub vs bot:</strong> {String(doc.logHubVsBotId)}
              </p>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
}
